import React, { useState, useEffect } from "react";
import { Dialog } from "@fuegokit/react/experimental";
import { Box, AtlasButton } from "@fuegokit/react";
import { AkEditorCloseIcon } from "@fuegokit/fuegoicons-react";
import {
  StyledDialogDemo,
  StyledDialogDemoOverlay,
  StyledDialogDemoContent,
  StyledDialogDemoTitle,
  StyledDialogDemoDescription,
  StyledDialogDemoButton,
  StyledDialogDemoIconButton,
  StyledDialogDemoFieldset,
  StyledDialogDemoLabel,
  StyledDialogDemoInput,
} from "../StoryStyles/DialogStyles";

const StyledDialogExample = () => {
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    setDomLoaded(true);
  }, []);
  return (
    <Box>
      {domLoaded && (
        <StyledDialogDemo defaultOpen={false}>
          <Dialog.Trigger asChild>
            <StyledDialogDemoButton sx={{ fontSize: 3 }}>
              Edit profile
            </StyledDialogDemoButton>
          </Dialog.Trigger>
          <Dialog.Portal>
            <StyledDialogDemoOverlay />
            <StyledDialogDemoContent>
              <StyledDialogDemoTitle>Edit profile</StyledDialogDemoTitle>
              <StyledDialogDemoDescription>
                Make changes to your profile here. Click save when you're done.
              </StyledDialogDemoDescription>
              <StyledDialogDemoFieldset>
                <StyledDialogDemoLabel htmlFor="name">
                  Name
                </StyledDialogDemoLabel>
                <StyledDialogDemoInput id="name" defaultValue="Matt Oliver" />
              </StyledDialogDemoFieldset>
              <StyledDialogDemoFieldset>
                <StyledDialogDemoLabel htmlFor="username">
                  Username
                </StyledDialogDemoLabel>
                <StyledDialogDemoInput id="username" defaultValue="@moliver" />
              </StyledDialogDemoFieldset>
              <Box
                sx={{
                  display: "flex",
                  marginTop: 25,
                  justifyContent: "flex-end",
                }}
              >
                <Dialog.Close asChild>
                  <AtlasButton appearance={`primary`}>Save changes</AtlasButton>
                </Dialog.Close>
              </Box>
              <Dialog.Close asChild>
                <StyledDialogDemoIconButton aria-label="Close">
                  <AkEditorCloseIcon />
                </StyledDialogDemoIconButton>
              </Dialog.Close>
            </StyledDialogDemoContent>
          </Dialog.Portal>
        </StyledDialogDemo>
      )}
    </Box>
  );
};
export default StyledDialogExample;
